import moment from 'moment';

export function formatDateTime(timestamp, format) {
    if (typeof format === 'undefined') {
        format = process.env.DATETIME_FORMAT;
    }

    if (typeof timestamp === 'number') {
        //Unix datetime
        return moment
            .unix(timestamp)
            .utc()
            .local()
            .format(format);
    } else {
        //Json datetime
        return moment
            .utc(timestamp)
            .local()
            .format(format);
    }
}
